import { Box } from '@mui/material';
import type { PropsWithChildren } from 'react';

export const InlineCode = ({ children }: PropsWithChildren) => {
  return (
    <Box
      component="code"
      sx={{
        fontFamily: '"Courier New", monospace',
        fontWeight: 700,
        fontSize: '85%',
        bgcolor: 'grey.100',
        borderRadius: 0.5,
        px: 0.75,
        py: 0.25,
      }}>
      {children}
    </Box>
  );
};
